import React, { useEffect, useState, useRef } from "react";
import {
  fetchBalaceList,
  // fetchBillingCardDetail,
  // fetchCardDetail,
  fetchDriverLoader,
  fetchMyOrderDetailCard,
  fetchMyOrderTimeline,
  fetchNewFlags,
  fetchOrderInvoice,
  fetchOrderSummaryListStripe,
  fetchPaymentInvoice,
  fetchSavedDriverLoader,
  fetchTransferTable,
  fetchUpcomingInvoiceDetail,
} from "./_redux/order/orderAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { AddEditStorage } from "./order-canva/AddEditStorage";
import { CustomerAttachment } from "../../../_metronic/layout/components/extras/offcanvas/Customers/CustomerAttachment";
import { CustomerBilling } from "./components/CustomerBillingComponents/CustomerBilling";
import { CustomerDetailEdit } from "./order-canva/CustomerDetailEdit";
import { CustomerOrderSummary } from "./components/CustomerOrderSummary";
import { DriverNotes } from "./order-canva/DriverNotes";
import { Feeds } from "../../../_metronic/_partials/widgets";
import { LoadingCustome } from "../../../_metronic/_partials/controls/LoadingCustome";
import { OrderCardWidget } from "./components/OrderCardWidget";
import { OrderCollection } from "./components/OrderCollection";
import OrderDetailDistance from "./components/OrderDetailDistance";
import { StoreProtectPolicyPanel } from "./components/StoreProtectPolicyPanel";
import { OrderDetailNotes } from "./components/OrderDetailNotes";
import { OrderNotesPanel } from "./components/OrderNotesPanel";
import { ScheduledPriceIncreaseInfo } from "./components/ScheduledPriceIncreaseInfo";
import { OrderDetailOfUpcomingInvoice } from "./components/OrderDetailOfUpcomingInvoice";
import { OrderInfo } from "../../../_metronic/_partials/widgets/order/OrderInfo";
import { OrderNotes } from "./order-canva/OrderNotes";
import { PaymentFailures } from "./components/PaymentFailures";
import { Payments } from "../../../_metronic/_partials/widgets/lists/Payments";
import SnackBarTool from "../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { StorageDetail } from "./order-canva/StorageDetail";
import { useLocation, useParams } from "react-router";
import {
  getHasArrear,
  getScheduleChanges,
  getSubDetail,
} from "./_redux/order/orderCrud";
import { OrderContainerCollection } from "./components/OrderContainerCollection";
import { ComplimentaryExtendedAccessPanel } from "./components/ComplimentaryExtendedAccessPanel";
import TransferTable from "./components/TransferTable";
import BalanceAdjustmentTable from "./components/BalanceAdjustTable";
import NotAuthorized from "../../../_metronic/_partials/widgets/NotAuthorized";
// import { abortApi } from "../../utils/commonFunction";

/**
 * Order detail screen for a single order — hosts the Customer Billing card,
 * Payments timeline, recorded Stripe payment-failure history, transfer table,
 * and the various edit canvases.
 *
 * The `payment_failures` array on `orderDetail` (populated by
 * `fetchMyOrderDetailCard`) feeds the new `PaymentFailures` block.
 *
 * The order id is read from the route via `useParams()` (react-router v7).
 *
 * @returns {JSX.Element} The order detail page.
 */
export const OrdersDetails = () => {
  const controllerRef = useRef(new AbortController());
  const location = useLocation();
  const { id } = useParams();
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  const [keyDis, setKeyDis] = useState("collection");
  const [scheduleData, setScheduleData] = useState(null);
  const [pagination, setPagination] = useState({
    starting_after: "",
    limit: 20,
    currentPage: 1,
    ending_before: "",
  });
  const [hasArrear, setHasArrear] = useState(null);
  const [openInvoice, setOpenInvoice] = useState({ open: false });
  const [subDetail, setSubDetail] = useState(null);
  const [isRelease, setIsRelease] = useState(false);

  const dispatch = useDispatch();
  const {
    orderDetail,
    timeline,
    cardDetailArray,
    billingCard,
    paymnetInvoiceList,
    editOrderDetail,
    orderInvoice,
    orderInvoiceLoading,
    driverLoader,
    detailDriverLoader,
    cardDetailCheck,
    transferList,
    traLoading,
    balanceList,
    orderSummaryListStripe,
    upComingLoading,
    upcomingInvoice,
  } = useSelector(
    (state) => ({
      orderDetail: state.order.orderDetail,
      editOrderDetail: state.order.editOrderTable,
      timeline: state.order.timeline,
      cardDetailArray: state.order.cardDetailArray,
      cardDetailCheck: state.order.cardDetailCheck,
      billingCard: state.order.billingCard,
      paymnetInvoiceList: state.order.paymentInvoiceList,
      orderInvoice: state.order.orderInvoice.data,
      orderInvoiceLoading: state.order.orderInvoice.loading,
      driverLoader: state.order.driverLoader,
      detailDriverLoader: state.order.savedDriverLoader,
      transferList: state.order.transferList,
      traLoading: state.order.traLoading,
      balanceList: state.order.balanceList,
      orderSummaryListStripe: state.order.orderSummaryListStripe,
      upComingLoading: state.order.upComingLoading,
      upcomingInvoice: state.order.upcomingInvoice,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(fetchMyOrderDetailCard(id));
    dispatch(fetchNewFlags(id));
    // dispatch(fetchOrderSummaryList(id, ""));
    dispatch(fetchMyOrderTimeline(id));
    dispatch(fetchBalaceList(id));
    // dispatch(fetchPaymentInvoice(id));
    dispatch(fetchOrderInvoice(id, controllerRef.current))
      .then(() => {})
      .catch((error) =>
        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.message,
          error: error?.response?.data?.errors,
        })
      );
    dispatch(fetchSavedDriverLoader(id));
  }, [dispatch, id]);

  useEffect(() => {
    const orderSub =
      orderDetail?.subscription_id || orderDetail?.subscription_scheduled_id;
    const is_subscription_id = orderDetail?.subscription_id ? 1 : "0";
    if (orderDetail.franchise_id) {
      dispatch(
        fetchPaymentInvoice(
          id,
          orderDetail?.franchise_id,
          orderSub,
          is_subscription_id,
          orderDetail?.invoice_id
        )
      );
      dispatch(fetchDriverLoader(orderDetail?.franchise_id));
    }
    if (
      orderDetail?.subscription_id ||
      orderDetail?.subscription_scheduled_id
    ) {
      getScheduleChanges(orderDetail?.franchise_id, orderSub)
        .then((res) => setScheduleData(res.data.data))
        .catch((error) => setScheduleData(null));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    orderDetail?.subscription_items?.next_billing_at,
    orderDetail?.customer_chargebee_id,
  ]);

  const { permission, statsData, role } = useSelector(
    (state) => ({
      permission: state.auth.permission,
      statsData: state.order.statsData,
      role: state.auth.user.roles,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (orderDetail?.customer_chargebee_id) {
      const data = {
        customer_id: orderDetail?.customer_chargebee_id,
        starting_after: pagination.starting_after,
        ending_before: pagination.ending_before,
        limit: pagination.limit,
      };
      dispatch(fetchTransferTable(data));
    }
  }, [orderDetail?.customer_chargebee_id, pagination]);

  // call api for upcoming invoice data
  useEffect(() => {
    if (orderDetail?.id) {
      const data = {
        order_id: orderDetail?.id,
      };
      dispatch(fetchUpcomingInvoiceDetail(data));
    }
  }, [orderDetail?.id]);

  useEffect(() => {
    const abortController = controllerRef.current;
    return () => {
      abortController.abort();
    };
  }, []);
  const [callApiHas, setcallApiHas] = useState(true);
  useEffect(() => {
    if (orderDetail?.customer_old_chargebee_id && callApiHas) {
      getHasArrear(orderDetail?.customer_old_chargebee_id).then((res) => {
        setHasArrear(res.data.data);
        setcallApiHas(false);
        console.log("helloop", res.data.data);
      });
    }
  }, [orderDetail?.customer_old_chargebee_id, callApiHas]);
  useEffect(() => {
    if (orderDetail?.subscription_data) {
      console.log("insurance_cover", orderDetail);
      getSubDetail(orderDetail?.subscription_id).then((res) => {
        console.log("res-900", res.data);
        setSubDetail(res.data.data);
      });

      // dispatchReducer({
      //   type: "SET_DATA",
      //   data: {
      //     ...state,
      //     ...orderDetail?.subscription_data,
      //     proration_behavior: "none",
      //     insurance_cover:
      //       orderDetail?.insurance_cover || insurance_cover?.cover || "",
      //     insurance_price: insurance_cover?.total || "",
      //   },
      // });
    }
  }, [orderDetail?.subscription_data]);
  return (
    <>
      {permission?.order?.edit ? (
        <>
        <div className="mt-5">
        <OrderInfo
          orderDetail={orderDetail}
          location={location}
        />
        </div>
        <div className="row">
          <div className="col-lg-6">
            <CustomerOrderSummary
              orderDetail={orderDetail}
              editOrderDetail={editOrderDetail}
              orderInvoice={orderInvoice}
              orderInvoiceLoading={orderInvoiceLoading}
              scheduleData={scheduleData}
              setScheduleData={setScheduleData}
              subDetail={subDetail}
              isRelease={isRelease}
            />
          </div>
          <div className="col-lg-6">
            {orderDetail?.is_container === 1 ? (
              <>
                <OrderContainerCollection
                  orderDetail={orderDetail}
                  setIsRelease={setIsRelease}
                />
                {/* Keyed by order, so one order's state never shows on another. */}
                <ComplimentaryExtendedAccessPanel
                  key={orderDetail?.id}
                  orderId={orderDetail?.id}
                />
              </>
            ) : (
              <div className="customercoll">
                <OrderCollection
                  orderDetail={orderDetail}
                  driverLoader={driverLoader}
                  detailDriverLoader={detailDriverLoader}
                  orderInvoice={orderInvoice}
                  billingCard={billingCard}
                  hasArrear={hasArrear}
                  setIsRelease={setIsRelease}
                />
              </div>
            )}
            <div>
              <OrderDetailDistance
                orderDetail={orderDetail}
                type="order"
                keyDis={keyDis}
                setKeyDis={setKeyDis}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4 col-md-12">
            <div className="customerbilling">
              <CustomerBilling
                billingCard={billingCard}
                paymentInvoice={paymnetInvoiceList}
                orderDetail={orderDetail}
                orderInvoice={orderInvoice}
                cardDetailArray={cardDetailArray}
                hasArrear={hasArrear}
                setcallApiHas={setcallApiHas}
                setOpenInvoice={setOpenInvoice}
                openInvoice={openInvoice}
              />
            </div>
          </div>
          <div className="col-xl-4 col-md-12 ">
            <Payments
              className="card-stretchs gutter-b"
              paymnetInvoiceList={paymnetInvoiceList}
            />
          </div>
          <div className="col-xl-4 col-md-12 ">
            <Feeds
              classNameSend="card-stretchs"
              data={timeline}
              type={"customer"}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <div className="customercarddtl">
              <OrderCardWidget
                cardDetailArray={cardDetailArray}
                cardDetailCheck={cardDetailCheck}
                orderDetail={orderDetail}
              />
            </div>
          </div>
          {upcomingInvoice && (
            <div className="col-8">
              <OrderDetailOfUpcomingInvoice
                upcomingInvoice={upcomingInvoice}
                title={"Upcoming Invoice"}
              />
            </div>
          )}
        </div>
        {orderDetail?.is_container == 1 &&
          String(orderDetail?.id) === String(id) && (
          <div className="row">
            <div className="col-12">
              {/* Shown only once the loaded order is the one in the address
                  bar: while another order is still loading, the previous
                  order must not be offered for an upload. Keyed by order, as
                  the page is not remounted when the id changes, so the chosen
                  file, refusal, reason and date never carry over. */}
              <StoreProtectPolicyPanel key={orderDetail?.id} orderId={orderDetail?.id} />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-6">
            <OrderDetailNotes orderDetail={orderDetail} title={"Driver Note"} />
          </div>
          <div className="col-6">
            <OrderDetailNotes
              title={"Driver Note from Mavis"}
              type={"note"}
              orderDetail={orderDetail}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {/* Keyed by order: moving to another order starts the panel afresh,
                so one order's notes are never shown under another. Held back
                until the order on screen is the one in the address bar, so a
                note is never posted to the order being navigated away from. */}
            {orderDetail?.id != null && String(orderDetail.id) === String(id) && (
              <OrderNotesPanel key={id} orderId={id} />
            )}
          </div>
        </div>
        {orderDetail?.p_increase_mail_date && orderDetail?.is_exempt_price != null && (
        <div className="row">
          <div className="col-12">
            <ScheduledPriceIncreaseInfo orderDetail={orderDetail} />
          </div>
        </div>
      )}
      
      <PaymentFailures paymentFailures={orderDetail?.payment_failures} />

      <div>
        <TransferTable
          transferList={transferList}
          setPagination={setPagination}
          pagination={pagination}
          traLoading={traLoading}
        />
      </div>
      <div>
        <h3 class="card-title align-items-start flex-column">
          <span class="font-weight-bolder text-dark">
            Credit balance adjustments
          </span>
        </h3>
        <BalanceAdjustmentTable
          balanceList={balanceList}
          transferList={transferList}
          setPagination={setPagination}
          pagination={pagination}
          traLoading={traLoading}
          orderDetail={orderDetail}
        />
      </div>
         <CustomerDetailEdit />

      <StorageDetail orderDetail={orderDetail} />

      <OrderNotes />
      <DriverNotes />

      <CustomerAttachment />
      <AddEditStorage />
 {orderDetail?.id ? "" : <LoadingCustome />}
      {snack.call ? <SnackBarTool {...snack} /> : ""}
        </>
      


   
     
      ) : (
          <NotAuthorized/>
      )}
    </>  
  );
};
